import React from "react";
import { Edit } from "react-admin";
import { MagazineTemplateForm } from "./MagazineTemplateForm";
export const MagazineTemplateEdit = (props) => (
    <Edit title="Gerar revista" {...props}>
        <MagazineTemplateForm {...props}/>
    </Edit>
);
